<template>
  <BaseModal
    :visible="visible"
    :title="title"
    width="700px"
    :showClose="true"
    @close="$emit('close')"
  >
    <div class="quality-faq">
      <div
        v-for="(item, idx) in faqs"
        :key="idx"
        class="faq-item"
      >
        <button
          type="button"
          class="faq-question"
          :aria-expanded="activeIndex === idx"
          @click="activeIndex = activeIndex === idx ? -1 : idx"
        >
          <span class="faq-left">
            <span class="faq-q">Q.</span>
            <span class="faq-text">{{ item.q }}</span>
          </span>
          <span class="faq-arrow" :class="{ open: activeIndex === idx }" />
        </button>

        <div v-show="activeIndex === idx" class="faq-answer">
          <p class="faq-answer-text">{{ item.a }}</p>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'

export default {
  name: 'QualityGuaranteeModal',
  components: { BaseModal },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    title() {
      return this.$t('quality_guarantee_modal.title')
    },
    faqs() {
      return [
        {
          q: this.$t('quality_guarantee_modal.faq1_q'),
          a: this.$t('quality_guarantee_modal.faq1_a')
        },
        {
          q: this.$t('quality_guarantee_modal.faq2_q'),
          a: this.$t('quality_guarantee_modal.faq2_a')
        }
      ]
    }
  },
  watch: {
    visible(val) {
      if (val) this.activeIndex = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.quality-faq {
  width: 100%;
}

.faq-item {
  padding: 0 0 14px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 14px;
}

.faq-question {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 14px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #333;
}

.faq-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.faq-q {
  font-weight: 600;
  color: #333;
  font-size: 17px;
}

.faq-text {
  font-size: 17px;
  color: #1a1a1a;
  line-height: 1.5;
}

.faq-arrow {
  width: 9px;
  height: 9px;
  border-right: 2px solid #999;
  border-bottom: 2px solid #999;
  transform: rotate(45deg);
  transition: transform 0.25s;
  flex-shrink: 0;
  margin-left: 12px;
}

.faq-arrow.open {
  transform: rotate(-135deg);
}

.faq-answer {
  padding: 0 0 6px 0;
}

.faq-answer-text {
  margin: 0;
  color: #666;
  font-size: 16px;
  line-height: 1.8;
}

@media (max-width: 768px) {
  .faq-text {
    font-size: 15px;
  }

  .faq-answer-text {
    font-size: 14px;
  }
}
</style>

